import { useState } from "react";
import {
    Container,
    Box,
    Paper,
    Typography,
    Tabs,
    Tab,
} from "@mui/material";
import Logocolor from "../Image/Logo.png";
import {
    Texto,
} from "../Layouts/CustomStyles";
import { CBODashboard } from "../Components/Dashboard/cbo";
import { RmeIndex } from "../Components/Dashboard/Rme";
import { useUserSuperEmpresa } from "../Context/AuthContext";
import { BuscadorAdmin } from "../Components/Dashboard/Buscador";

export const PagesDashboard = () => {
    const { Usuario } = useUserSuperEmpresa();
    const roleId = Usuario?.id;
    const esRolLimitado = roleId === 2;

    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event, newValue) => setTabIndex(newValue);
    return (
        <Container maxWidth="xxl" sx={{ py: 5 }}>
            <Paper
                elevation={4}
                sx={{
                    p: 4,
                    borderRadius: "20px",
                    background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                }}
            >
                <Box sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Box display="flex" alignItems="center" gap={2}>
                        <img
                            src={Logocolor}
                            alt="Logo Clínica Activa"
                            style={{ width: 55, height: 55, objectFit: "contain" }}
                        />
                        <Typography variant="h5" sx={Texto}>
                            Reportes Alemana Activa
                        </Typography>
                    </Box>

                </Box>
                <Box sx={{ mt: 5 }}>
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                        variant="scrollable"  
                        scrollButtons={false}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#6fd385ff", 
                                height: "3px",             
                                borderRadius: "2px",       
                            },
                        }}
                        sx={{
                            "& .MuiTab-root": {
                                minWidth: "auto",
                                px: 2,
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                borderRadius: "8px 8px 0 0", 
                            },
                            "& .Mui-selected": {
                                backgroundColor: "#2a8d74", 
                                color: "#fff !important",   
                            },
                        }}>
                       {!esRolLimitado && <Tab label="Reporte CBO" />}
    {!esRolLimitado && <Tab label="Reporte RME" />}

    {/* 👉 SOLO ADMIN */}
    {esRolLimitado && <Tab label="Buscador Administrador" />}
                    </Tabs>

{/* 👉 ADMIN */}
{esRolLimitado && tabIndex === 0 && (
    <BuscadorAdmin/>
)}

{/* 👉 NO ADMIN */}
{!esRolLimitado && tabIndex === 0 && <CBODashboard />}
{!esRolLimitado && tabIndex === 1 && <RmeIndex />}
                </Box>
            </Paper>
        </Container>
    )
}